import { combineEpics } from 'redux-observable'
import initiate$ from './initiate'
import addEvents$ from './addEvents'

export default combineEpics(
  initiate$,
  addEvents$
)
